// hardcoded item_types on BE, full list could be found on https://shopometry.atlassian.net/browse/PBR-721?focusedCommentId=15962

export const TYPE_CAMPAIGN = 'campaign'
export const TYPE_LINE_ITEM = 'line_item'
export const TYPE_AD = 'visual'
export const TYPE_ASSET_GROUP = 'asset_group'

export const historyTypesLabel = {
  [TYPE_CAMPAIGN]: 'Campaign',
  [TYPE_LINE_ITEM]: 'Line item',
  [TYPE_AD]: 'Ad',
  [TYPE_ASSET_GROUP]: 'Ad'
}

export const HISTORY_META_EDIT_SECTION = 'edit_section'
